import { apiClient } from './api.client';
import { API_CONFIG, API_ENDPOINTS } from '../config/api.config';
import { AuthResponse, LoginRequest } from '../types';

export const authService = {
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>(
      API_ENDPOINTS.AUTH.LOGIN,
      credentials
    );
    
    const { accessToken, ...userData } = response.data;
    localStorage.setItem(API_CONFIG.TOKEN_KEY, accessToken);
    localStorage.setItem(API_CONFIG.USER_KEY, JSON.stringify(userData));
    
    return response.data;
  },

  logout: () => {
    localStorage.removeItem(API_CONFIG.TOKEN_KEY);
    localStorage.removeItem(API_CONFIG.USER_KEY);
  },

  getToken: (): string | null => {
    return localStorage.getItem(API_CONFIG.TOKEN_KEY);
  },

  getCurrentUser: (): AuthResponse | null => {
    const userStr = localStorage.getItem(API_CONFIG.USER_KEY);
    if (!userStr) return null;
    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  },

  isAuthenticated: (): boolean => {
    return !!authService.getToken();
  },

  refreshUser: async (): Promise<AuthResponse | null> => {
    const token = authService.getToken();
    if (!token) return null;
    
    try {
      const userStr = localStorage.getItem(API_CONFIG.USER_KEY);
      if (!userStr) return null;
      
      const response = await apiClient.get<AuthResponse>(`/api/auth/me`);
      
      const updatedUser = { ...response.data, accessToken: token };
      localStorage.setItem(API_CONFIG.USER_KEY, JSON.stringify(updatedUser));
      
      return updatedUser;
    } catch (error) {
      return null;
    }
  },
};
